import Vue from '../consts/vue'
import sanitizeHtml from 'sanitize-html'

Vue.prototype.$sanitize = sanitizeHtml
